module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "budget-followup-cph"
  }, [(_vm.data) ? _c('div', [(_vm.graphModal) ? _c('div', {
    staticClass: "graph-modal"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "inner__title"
  }, [_vm._v("\n                    Udvikling i DB pr. time for \"" + _vm._s(_vm.graphModal.name) + "\"\n                ")]), _vm._v(" "), _c('div', [_c('vue-apex-charts', {
    attrs: {
      "height": 400,
      "series": _vm.graphModal.graph,
      "options": _vm.graphOptions
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "close-wrapper"
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.graphModal = null
      }
    }
  }, [_vm._v("\n                        Luk\n                    ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "identifier": "budgetfollowup.cph",
      "placement": "left"
    }
  }), _vm._v("\n                Opgavetyper\n            ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.data.budget.ebitda_goal)))]), _vm._v("\n                            Ønsket EBITDA"), _c('br'), _vm._v("(driftsoverskud)\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "color-avg",
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.data.budget.cph_zero_revenue)))]), _vm._v("\n                            Krav til DB pr. time for at nå nulpunktsomsætning\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "color-good",
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.data.budget.cph_goal_ebitda)))]), _vm._v("\n                            Krav til DB pr. time for at nå ønsket EBITDA\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    class: {
      'color-bad': _vm.data.total_coverage_per_hour < _vm.data.budget.cph_zero_revenue, 'color-avg': _vm.data.total_coverage_per_hour < _vm.data.budget.cph_goal_ebitda, 'color-good': _vm.data.total_coverage_per_hour > _vm.data.budget.cph_goal_ebitda
    },
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.data.total_coverage_per_hour)))]), _vm._v("\n                            DB pr. time"), _c('br'), _vm._v("(realiseret)\n                        ")])])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.data.project_types), function(projectType, index) {
    return _c('tr', {
      key: 'cphProjectType_' + index
    }, [_c('td', {
      staticClass: "table-column__description",
      attrs: {
        "align": "left",
        "title": projectType.name
      }
    }, [_vm._v("\n                                " + _vm._s(projectType.name) + "\n                            ")]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(projectType.hours)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(projectType.projects_count)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-weight": "bold"
      },
      attrs: {
        "align": "right"
      }
    }, [(projectType.coverage_per_hour !== 0) ? _c('span', [_c('span', {
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "flex-end"
      }
    }, [(projectType.coverage_per_hour > _vm.data.budget.cph_goal_ebitda) ? _c('span', {
      staticClass: "color-good"
    }, [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(projectType.coverage_per_hour)) + "\n                                        ")]) : (projectType.coverage_per_hour > _vm.data.budget.cph_zero_revenue) ? _c('span', {
      staticClass: "color-avg"
    }, [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(projectType.coverage_per_hour)) + "\n                                        ")]) : _c('span', {
      staticClass: "color-bad"
    }, [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(projectType.coverage_per_hour)) + "\n                                        ")])])]) : _c('span', [_vm._v("\n                                    -\n                                ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "left"
      }
    }, [(projectType.coverage_per_hour !== 0) ? _c('span', [_c('span', {
      staticStyle: {
        "font-size": "14px"
      }
    }, [(projectType.direction === 'up') ? _c('i', {
      staticClass: "fas fa-arrow-up fa-fw color-good"
    }) : _vm._e(), _vm._v(" "), (projectType.direction === 'down') ? _c('i', {
      staticClass: "fas fa-arrow-down fa-fw color-bad"
    }) : _vm._e(), _vm._v(" "), (projectType.direction === 'neutral') ? _c('i', {
      staticClass: "fas fa-arrow-right fa-fw color-avg"
    }) : _vm._e()]), _vm._v(" "), _c('i', {
      staticClass: "fas fa-chart-bar fa-fw",
      on: {
        "click": function($event) {
          _vm.graphModal = projectType
        }
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "budget",
      attrs: {
        "align": "right"
      }
    }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(projectType.budget)) + "\n                            ")]), _vm._v(" "), (projectType.coverage_per_hour !== 0) ? _c('td', {
      class: {
        'color-bad': (Math.round(projectType.coverage_per_hour) - Math.round(projectType.budget)) < 0, 'color-good': (Math.round(projectType.coverage_per_hour) - Math.round(projectType.budget)) > 0
      },
      attrs: {
        "align": "right"
      }
    }, [((Math.round(projectType.coverage_per_hour) - Math.round(projectType.budget)) > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(Math.round(projectType.coverage_per_hour) - Math.round(projectType.budget))) + "\n                            ")]) : _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v("\n                                -\n                            ")])])
  }), 0)])])])]) : _c('div', [_c('box-loading')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Opgavetype")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "15%"
    }
  }, [_vm._v("Antal timer")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "15%"
    }
  }, [_vm._v("Antal opgaver")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "15%"
    }
  }, [_vm._v("Realiseret")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left",
      "width": "5%"
    }
  }, [_c('span', {
    staticStyle: {
      "opacity": "0.5"
    }
  }, [_vm._v(" Udv.")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "15%"
    }
  }, [_vm._v("Budget")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "15%"
    }
  }, [_vm._v("Difference")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd4df050"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/economy/learning/components/budgetCph.vue
// module id = 925
// module chunks = 0